module.exports = ".modal-dialog {\n  font-size: larger;\n}\n\n.modal-html-content {\n  white-space: pre-wrap;\n}\n\n.buttons {\n  text-align: right;\n}"